const GET_POSTING_INFO = 'desempeno/desempeno/GET_POSTING_INFO';
const GET_POSTING_INFO_COMPLETED = 'desempeno/desempeno/GET_POSTING_INFO_COMPLETED';
const GET_POSTING_INFO_FAILED = 'desempeno/desempeno/GET_POSTING_INFO_FAILED';
const GET_IMPRESSIONS = 'desempeno/desempeno/GET_IMPRESSIONS';
const GET_IMPRESSIONS_COMPLETED = 'desempeno/desempeno/GET_IMPRESSIONS_COMPLETED';
const GET_IMPRESSIONS_FAILED = 'desempeno/desempeno/GET_IMPRESSIONS_FAILED';
const GET_VISITS = 'desempeno/desempeno/GET_VISITS';
const GET_VISITS_COMPLETED = 'desempeno/desempeno/GET_VISITS_COMPLETED';
const GET_VISITS_FAILED = 'desempeno/desempeno/GET_VISITS_FAILED';
const GET_LEADS = 'desempeno/desempeno/GET_LEADS';
const GET_LEADS_COMPLETED = 'desempeno/desempeno/GET_LEADS_COMPLETED';
const GET_LEADS_FAILED = 'desempeno/desempeno/GET_LEADS_FAILED';
const GET_POSTING_QUALITY = 'desempeno/desempeno/GET_POSTING_QUALITY';
const GET_POSTING_QUALITY_COMPLETED = 'desempeno/desempeno/GET_POSTING_QUALITY_COMPLETED';
const GET_POSTING_QUALITY_FAILED = 'desempeno/desempeno/GET_POSTING_QUALITY_FAILED';
const GET_AUTHORIZATION = 'desempeno/desempeno/GET_AUTHORIZATION';
const GET_AUTHORIZATION_COMPLETED = 'desempeno/desempeno/GET_AUTHORIZATION_COMPLETED';
const GET_AUTHORIZATION_FAILED = 'desempeno/desempeno/GET_AUTHORIZATION_FAILED';
const GET_LEADS_STATS = 'desempeno/desempeno/GET_LEADS_STATS';
const GET_LEADS_STATS_COMPLETED = 'desempeno/desempeno/GET_LEADS_STATS_COMPLETED';
const GET_POSTING_LOGS = 'desempeno/desempeno/GET_POSTING_LOGS';
const GET_POSTING_LOGS_COMPLETED = 'desempeno/desempeno/GET_POSTING_LOGS_COMPLETED';
const GET_POSTING_TIPS = 'desempeno/desempeno/GET_POSTING_TIPS';
const GET_POSTING_TIPS_COMPLETED = 'desempeno/desempeno/GET_POSTING_TIPS_COMPLETED';
const GET_POSTING_TIPS_FAILED = 'desempeno/desempeno/GET_POSTING_TIPS_FAILED';
const FETCH_REPORTS = 'desempeno/desempeno/FETCH_REPORTS';
const FETCH_REPORTS_COMPLETED = 'desempeno/desempeno/FETCH_REPORTS_COMPLETED';
const FETCH_REPORTS_FAILED = 'desempeno/desempeno/FETCH_REPORTS_FAILED';
const SAVE_POSTING_TAG = 'desempeno/desempeno/SAVE_POSTING_TAG';
const SAVE_POSTING_TAG_COMPLETED = 'desempeno/desempeno/SAVE_POSTING_TAG_COMPLETED';
const SAVE_POSTING_TAG_FAILED = 'desempeno/desempeno/SAVE_POSTING_TAG_FAILED';
const CHECK_POSTING_REPORT = 'desempeno/desempeno/CHECK_POSTING_REPORT';
const CHECK_POSTING_REPORT_COMPLETED = 'desempeno/desempeno/CHECK_POSTING_REPORT_COMPLETED';
const CHECK_POSTING_REPORT_FAILED = 'desempeno/desempeno/CHECK_POSTING_REPORT_FAILED';
const FETCH_CREDITS = 'desempeno/desempeno/FETCH_CREDITS';
const FETCH_CREDITS_COMPLETED = 'desempeno/desempeno/FETCH_CREDITS_COMPLETED';
const FETCH_CREDITS_FAILED = 'desempeno/desempeno/FETCH_CREDITS_FAILED';
const SELECT_CREDIT = 'desempeno/desempeno/SELECT_CREDIT';
const SELECT_CREDIT_COMPLETED = 'desempeno/desempeno/SELECT_CREDIT_COMPLETED';
const SELECT_CREDIT_FAILED = 'desempeno/desempeno/SELECT_CREDIT_FAILED';
const PUBLISH_POSTING = 'desempeno/desempeno/PUBLISH_POSTING';
const PUBLISH_POSTING_COMPLETED = 'desempeno/desempeno/PUBLISH_POSTING_COMPLETED';
const PUBLISH_POSTING_FAILED = 'desempeno/desempeno/PUBLISH_POSTING_FAILED';
const UPDATE_POSTING_INFO = 'desempeno/desempeno/UPDATE_POSTING_INFO';
const UPDATE_POSTING_INFO_COMPLETED = 'desempeno/desempeno/UPDATE_POSTING_INFO_COMPLETED';
const UPDATE_POSTING_INFO_FAILED = 'desempeno/desempeno/UPDATE_POSTING_INFO_FAILED';
const SAVE_SHARED_PERFORMANCE = 'desempeno/desempeno/SAVE_SHARED_PERFORMANCE';
const SAVE_SHARED_PERFORMANCE_COMPLETED = 'desempeno/desempeno/SAVE_SHARED_PERFORMANCE_COMPLETED';
const SAVE_SHARED_PERFORMANCE_FAILED = 'desempeno/desempeno/SAVE_SHARED_PERFORMANCE_FAILED';
const GET_FINISH_REASON = 'desempeno/desempeno/GET_FINISH_REASON';
const GET_FINISH_REASON_COMPLETED = 'desempeno/desempeno/GET_FINISH_REASON_COMPLETED';
const GET_FINISH_REASON_FAILED = 'desempeno/desempeno/GET_FINISH_REASON_FAILED';
const SUSPEND_POSTING = 'desempeno/desempeno/SUSPEND_POSTING';
const SUSPEND_POSTING_COMPLETED = 'desempeno/desempeno/SUSPEND_POSTING_COMPLETED';
const SUSPEND_POSTING_FAILED = 'desempeno/desempeno/SUSPEND_POSTING_FAILED';
const SHOW_UNREAD_LEADS_MODAL = 'desempeno/desempeno/SHOW_UNREAD_LEADS_MODAL';
const SEND_UNREAD_LEADS_MSG = 'desempeno/desempeno/SEND_UNREAD_LEADS_MSG';
const SEND_UNREAD_LEADS_MSG_COMPLETED = 'desempeno/desempeno/SEND_UNREAD_LEADS_MSG_COMPLETED';
const SEND_UNREAD_LEADS_MSG_FAILED = 'desempeno/desempeno/SEND_UNREAD_LEADS_MSG_FAILED';
const HAS_UNREAD_LEADS = 'desempeno/desempeno/HAS_UNREAD_LEADS';
const HAS_UNREAD_LEADS_COMPLETED = 'desempeno/desempeno/HAS_UNREAD_LEADS_COMPLETED';
const HAS_UNREAD_LEADS_FAILED = 'desempeno/desempeno/HAS_UNREAD_LEADS_FAILED';
const POSTING_FULL_INFO = 'desempeno/desempeno/POSTING_FULL_INFO';
const POSTING_FULL_INFO_COMPLETED = 'desempeno/desempeno/POSTING_FULL_INFO_COMPLETED';
const POSTING_FULL_INFO_FAILED = 'desempeno/desempeno/POSTING_FULL_INFO_FAILED';

export {
  GET_POSTING_INFO,
  GET_POSTING_INFO_COMPLETED,
  GET_POSTING_INFO_FAILED,
  GET_IMPRESSIONS,
  GET_IMPRESSIONS_COMPLETED,
  GET_IMPRESSIONS_FAILED,
  GET_VISITS,
  GET_VISITS_COMPLETED,
  GET_VISITS_FAILED,
  GET_LEADS,
  GET_LEADS_COMPLETED,
  GET_LEADS_FAILED,
  GET_POSTING_QUALITY,
  GET_POSTING_QUALITY_COMPLETED,
  GET_POSTING_QUALITY_FAILED,
  GET_AUTHORIZATION,
  GET_AUTHORIZATION_COMPLETED,
  GET_AUTHORIZATION_FAILED,
  GET_LEADS_STATS,
  GET_LEADS_STATS_COMPLETED,
  GET_POSTING_LOGS,
  GET_POSTING_LOGS_COMPLETED,
  GET_POSTING_TIPS,
  GET_POSTING_TIPS_COMPLETED,
  GET_POSTING_TIPS_FAILED,
  FETCH_REPORTS,
  FETCH_REPORTS_COMPLETED,
  FETCH_REPORTS_FAILED,
  SAVE_POSTING_TAG,
  SAVE_POSTING_TAG_COMPLETED,
  SAVE_POSTING_TAG_FAILED,
  CHECK_POSTING_REPORT,
  CHECK_POSTING_REPORT_COMPLETED,
  CHECK_POSTING_REPORT_FAILED,
  FETCH_CREDITS,
  FETCH_CREDITS_COMPLETED,
  FETCH_CREDITS_FAILED,
  SELECT_CREDIT,
  SELECT_CREDIT_COMPLETED,
  SELECT_CREDIT_FAILED,
  PUBLISH_POSTING,
  PUBLISH_POSTING_COMPLETED,
  PUBLISH_POSTING_FAILED,
  UPDATE_POSTING_INFO,
  UPDATE_POSTING_INFO_COMPLETED,
  UPDATE_POSTING_INFO_FAILED,
  SAVE_SHARED_PERFORMANCE,
  SAVE_SHARED_PERFORMANCE_COMPLETED,
  SAVE_SHARED_PERFORMANCE_FAILED,
  GET_FINISH_REASON,
  GET_FINISH_REASON_COMPLETED,
  GET_FINISH_REASON_FAILED,
  SUSPEND_POSTING,
  SUSPEND_POSTING_COMPLETED,
  SUSPEND_POSTING_FAILED,
  SHOW_UNREAD_LEADS_MODAL,
  SEND_UNREAD_LEADS_MSG,
  SEND_UNREAD_LEADS_MSG_COMPLETED,
  SEND_UNREAD_LEADS_MSG_FAILED,
  HAS_UNREAD_LEADS,
  HAS_UNREAD_LEADS_COMPLETED,
  HAS_UNREAD_LEADS_FAILED,
  POSTING_FULL_INFO,
  POSTING_FULL_INFO_COMPLETED,
  POSTING_FULL_INFO_FAILED
};
